export default "__VITE_ASSET__ByRqrb4u__"